import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PortalAuthProvider } from './context/PortalAuthContext'; // ← AJOUTÉ
import PortalLayout from './components/layout/PortalLayout';
import PortalNotificationsPage from './pages/portal/PortalNotificationsPage';
import PortalInvoicesPage from './pages/portal/PortalInvoicesPage';
import PortalMaintenancePage from './pages/portal/PortalMaintenancePage';
import PortalPaymentsPage from './pages/portal/PortalPaymentsPage';
import PortalPaymentCheckoutPage from './pages/portal/PortalPaymentCheckoutPage';
import PortalLeasePaymentsPage from './pages/portal/PortalLeasePaymentsPage';
import PortalDashboardPage from './pages/portal/PortalDashboardPage';
import PortalLoginPage from './pages/portal/PortalLoginPage';
import PortalAnnouncementsPage from './pages/portal/PortalAnnouncementsPage';
import Layout from './components/layout/Layout';
import LandingPage from './pages/LandingPage';
import InventoriesList from './pages/inventories/InventoriesList';
import InventoryBuilder from './pages/inventories/InventoryBuilder';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import ProfilePage from './pages/auth/ProfilePage';
import DashboardPage from './pages/dashboard/DashboardPage';
import PropertyListPage from './pages/properties/PropertyListPage';
import PropertyDetailPage from './pages/properties/PropertyDetailPage';
import PropertyUnitDetailPage from './pages/properties/PropertyUnitDetailPage';
import LeaseListPage from './pages/leases/LeaseListPage';
import LeaseDetailPage from './pages/leases/LeaseDetailPage';
import InvoiceListPage from './pages/invoices/InvoiceListPage';
import InvoiceDetailPage from './pages/invoices/InvoiceDetailPage';
import ClientListPage from './pages/clients/ClientListPage';
import ClientDetailPage from './pages/clients/ClientDetailPage';
import LeadListPage from './pages/leads/LeadListPage';
import TenantListPage from './pages/tenants/TenantListPage';
import TenantDetailPage from './pages/tenants/TenantDetailPage';
import MaintenanceListPage from './pages/maintenance/MaintenanceListPage';
import MaintenanceDetailPage from './pages/maintenance/MaintenanceDetailPage';
import AnnouncementListPage from './pages/announcements/AnnouncementListPage';
import NotificationPage from './pages/notifications/NotificationPage';
import DocumentListPage from './pages/documents/DocumentListPage';
import AnnouncementDetailPage from './pages/announcements/AnnouncementDetailPage';
import AnnouncementPublicPage from './pages/announcements/AnnouncementPublicPage';
import UserManagementPage from './pages/clients/UserManagementPage';
import AgencyPaymentMethode from './pages/payments/AgencyPaymentMethodsPage';
import PaymentIntentListPage from './pages/payments/PaymentIntentListPage';
import PaymentListPage from './pages/payments/PaymentListPage';
import LeadDetailPage from './pages/leads/LeadDetailPage';
import MandateListPage from './pages/mandates/MandateListPage';
import MandateDetailPage from './pages/mandates/MandateDetailPage';
import ReportPage from './pages/reports/ReportPage';
import AgencyPage from './pages/agency/AgencyPage';
import SalesListPage from './pages/sales/SalesListPage';
import SaleDetailPage from './pages/sales/SaleDetailPage';
import LitigationsListPage from './pages/litigations/LitigationsListPage';
import LitigationDetailPage from './pages/litigations/LitigationDetailPage';
import SuperAdminDashboardPage from './pages/admin/SuperAdminDashboardPage';
import AgenciesManagementPage from './pages/admin/AgenciesManagementPage';
import SmsOrdersPage from './pages/admin/SmsOrdersPage';
import SmsLogsPage from './pages/admin/SmsLogsPage';
import SmsPackPlansPage from './pages/admin/SmsPackPlansPage';
import SmsPacksPage from './pages/agency/SmsPacksPage';
import AgencyExpensesPage from './pages/expenses/AgencyExpensesPage';
import './App.css';
import PortalInvoiceDetailPage from './pages/portal/PortalInvoiceDetailPage';

function App() {
  return (
    <PortalAuthProvider> {/* ← AJOUTÉ : enveloppe tout */}
      <AuthProvider>
        <Router>
          <Routes>
            {/* --- Pages publiques --- */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/annonces/:slug" element={<AnnouncementPublicPage />} />
            
            {/* --- Portail Client / Locataire --- */}
            <Route path="/portal/login" element={<PortalLoginPage />} />
            <Route path="/portal" element={<PortalLayout />}>
              <Route index element={<Navigate to="/portal/dashboard" replace />} />
              <Route path="dashboard" element={<PortalDashboardPage />} />
              <Route path="invoices" element={<PortalInvoicesPage />} />
              <Route path="invoices/:id" element={<PortalInvoiceDetailPage/>}/>
              <Route path="payments" element={<PortalPaymentsPage />} />
              <Route path="lease-payments/:id/checkout" element={<PortalPaymentCheckoutPage />} />
              <Route path="lease-payments" element={<PortalLeasePaymentsPage />} />
              <Route path="lease-payments/:id" element={<PortalLeasePaymentsPage />} />

              <Route path="maintenance" element={<PortalMaintenancePage />} />
              <Route path="announcements" element={<PortalAnnouncementsPage />} />
              <Route path="notifications" element={<PortalNotificationsPage />} />
              <Route path="profile" element={<div>Profil Portail (à créer)</div>} />
              <Route path="*" element={<Navigate to="/portal/dashboard" replace />} />
            </Route>

            {/* --- Application Admin / Agence --- */}
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/properties" element={<PropertyListPage />} />
              <Route path="/properties/:id" element={<PropertyDetailPage />} />
              <Route path="/properties/:id/units/:unitId" element={<PropertyUnitDetailPage />} />
              <Route path="/sales" element={<SalesListPage />} />
              <Route path="/sales/:id" element={<SaleDetailPage />} />
              <Route path="/litigations" element={<LitigationsListPage />} />
              <Route path="/litigations/:id" element={<LitigationDetailPage />} />
              <Route path="/leases" element={<LeaseListPage />} />
              <Route path="/leases/:id" element={<LeaseDetailPage />} />
              <Route path="/invoices" element={<InvoiceListPage />} />
              <Route path="/invoices/:id" element={<InvoiceDetailPage />} />
              <Route path="/payment-intents" element={<PaymentIntentListPage />} />
              <Route path="/PaymentList" element={<PaymentListPage />} />
              <Route path="/agency-payment-methods" element={<AgencyPaymentMethode />} />
              <Route path="/inventories" element={<InventoriesList />} />
              <Route path="/inventories/new" element={<InventoryBuilder />} />
              <Route path="/inventories/:id" element={<InventoryBuilder />} />
              <Route path="/clients" element={<ClientListPage />} />
              <Route path="/clients/:id" element={<ClientDetailPage />} />
              <Route path="/leads" element={<LeadListPage />} />
              <Route path="/leads/:id" element={<LeadDetailPage />} />
              <Route path="/tenants" element={<TenantListPage />} />
              <Route path="/tenants/:id" element={<TenantDetailPage />} />
              <Route path="/announcements" element={<AnnouncementListPage />} />
              <Route path="/announcements/:slug" element={<AnnouncementDetailPage />} />
              <Route path="/maintenance" element={<MaintenanceListPage />} />
              <Route path="/maintenance/:id" element={<MaintenanceDetailPage />} />
              <Route path="/users" element={<UserManagementPage />} />
              <Route path="/agency" element={<AgencyPage />} />
              <Route path="/agency/sms-packs" element={<SmsPacksPage />} />
              <Route path="/expenses" element={<AgencyExpensesPage />} />
              <Route path="/payments" element={<PaymentListPage />} />
              <Route path="/mandates" element={<MandateListPage />} />
              <Route path="/mandates/:id" element={<MandateDetailPage />} />
              <Route path="/notifications" element={<NotificationPage />} />
              <Route path="/documents" element={<DocumentListPage />} />
              <Route path="/reports" element={<ReportPage />} />

              {/* Super Admin Routes */}
              <Route path="/admin/dashboard" element={<SuperAdminDashboardPage />} />
              <Route path="/admin/agencies" element={<AgenciesManagementPage />} />
              <Route path="/admin/sms-pack-plans" element={<SmsPackPlansPage />} />
              <Route path="/admin/sms-orders" element={<SmsOrdersPage />} />
              <Route path="/admin/sms-logs" element={<SmsLogsPage />} />
            </Route>

            {/* Fallback global */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </PortalAuthProvider>
  );
}

export default App;